export const decodeText = (text) => {
  const e = document.createElement("p");
  e.innerHTML = text
    .replaceAll("@BR", "</br>")
    .replaceAll("[", '<span class="text-qprimary">')
    .replaceAll("]", "</span>")
    .replaceAll("{", '<span class="text-qmark">')
    .replaceAll("}", "</span>")
    .replaceAll("<-", '<b>')
    .replaceAll("->", "</b>");
  return e.childNodes.length === 0 ? "" : e.innerHTML;
}